const translations = {
    en: {
        events: {
            category_explorer: {
                categories: "CATEGORIES"
            }
        }
    },
    de: {
        events: {
            category_explorer: {
                categories: "KATEGORIE"
            }
        }
    },
    es: {
        events: {
            category_explorer: {
                categories: "Categorías"
            }
        }
    },
    fr: {
        events: {
            category_explorer: {
                categories: "CATÉGORIES"
            }
        }
    },
    it: {
        events: {
            category_explorer: {
                categories: "CATEGORIE"  
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/events/CategoryExplorer.js